import { ScorecardStatus } from 'store/interfaces';
import {
  SCORECARD_STATUS_ACTIVE,
  SCORECARD_STATUS_GOALS_APPROVED,
  SCORECARD_STATUS_GOALS_PREPARED,
} from 'constants/scorecards';

interface CanDeleteOwnScorecardArgs {
  status: ScorecardStatus;
  isOwnScorecardsPage: boolean;
}

/**
 * Owners may delete their own scorecards - manual or published from a template - only before
 * assessment starts, narrower than the privileged deletion, which stays available in the later states.
 */
export default function canDeleteOwnScorecard({
  status,
  isOwnScorecardsPage,
}: CanDeleteOwnScorecardArgs): boolean {
  return (
    isOwnScorecardsPage &&
    (
      [
        SCORECARD_STATUS_ACTIVE,
        SCORECARD_STATUS_GOALS_PREPARED,
        SCORECARD_STATUS_GOALS_APPROVED,
      ] as ScorecardStatus[]
    ).includes(status)
  );
}
